import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "shop-form__block" }
const _hoisted_2 = ["onClick"]

import { computed } from "vue";
import { useStore } from "vuex";
import { TypeLoyalityKinds } from "@/types";
import {
  IloyalityShopData,
  TypeReceiver,
  TypeSortedLoyalityByName,
} from "@/types/typesOfState";
import { Store } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'stepSetLoyality',
  setup(__props) {

const store = useStore();

const loyalityShopData = computed<IloyalityShopData>(
  () => store.state.loyalityShopData
);
const currentLoyalityKind = computed<TypeLoyalityKinds>(
  () => store.state.currentLoyalityKind
);

const sortedLoyalityByName = computed<TypeSortedLoyalityByName>(
  () => store.state.sortedLoyalityByName
);

const currentCertificateName = computed<string>(
  () => store.state.loyalityShopData.byCertificate.name
);
const currentAbonementName = computed<string>(
  () => store.state.loyalityShopData.byAbonement.name
);

function setLoyality(loyalityName: string): void {
  if (currentLoyalityKind.value === 'certificate') {
    store.state.loyalityShopData.byCertificate.name = loyalityName;
    const currentSortedLoyalityByName = store.state.sortedLoyalityByName.certificates[loyalityName]
    if (currentSortedLoyalityByName.list.length === 1) {
      
      store.state.loyalityShopData.buyLoyalityType = currentSortedLoyalityByName.list[0].id
      store.state.loyalityShopData.byCertificate.seanceLength = currentSortedLoyalityByName.minutesArray[0]
      store.state.loyalityShopData.byCertificate.nominal = currentSortedLoyalityByName.nominalsArray[0]
    }
  } else {
    store.state.loyalityShopData.byAbonement.name = loyalityName;
  }
  
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentLoyalityKind.value === 'certificate' ? sortedLoyalityByName.value.certificates : sortedLoyalityByName.value.abonements, (sortedItemType, sortedItemName) => {
      return (_openBlock(), _createElementBlock("span", {
        class: _normalizeClass(["button grey", {
        active: sortedItemName === (currentLoyalityKind.value === 'certificate' ? currentCertificateName.value : currentAbonementName.value)
      }]),
        key: sortedItemType.id,
        onClick: ($event: any) => (setLoyality(sortedItemName))
      }, _toDisplayString(sortedItemType.title), 11, _hoisted_2))
    }), 128))
  ]))
}
}

})